import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Grid,
  Hidden,
  IconButton,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationAssignCampaignSchema } from "../../components/Ai-Saas/CreateAIData/fieldsConfig";
import { useDispatch, useSelector } from "react-redux";
import { getUnassignedCampaigns } from "../../redux/actions/campaign.actions";
import {
  assignCampaign,
  deleteAssignedCampaignById,
  getAllAiAgentDetails,
  getUnAssignedCampaigns,
} from "../../redux/actions/ai_functions";
import { getAllAiAssignedCampaigns } from "../../redux/actions/ai_functions";
import { v4 as uuidv4 } from "uuid"; // Optionally use uuid for unique IDs

export default function Table(props) {
  const [open, setOpen] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const [assignCampModal, setAssignCampModal] = React.useState(false);
  const [assignedCampData, setAssignedCampData] = React.useState([]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationAssignCampaignSchema),
    defaultValues: {
      ai_id: "",
      campaign_id: "",
    },
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseModal = () => {
    setAssignCampModal(false);
    setValue("ai_id", "");
    setValue("campaign_id", "");
  };
  const { setShowDialog, activeTab, setActiveTab } = props;

  const { allAgentDetails, allAssignedCampaignsDetails, unassignedCampaigns } =
    useSelector((state) => state?.aiDataReducer);

  function handleViewClick(id) {
    setOpen(true);
    const selectedRowData = assignedCampData?.find((data) => data.id === id);
    setModalData(selectedRowData);
    setShowDialog(false);
  }

  function handleEditClick(id) {
    setAssignCampModal(true);
    const selectedRowData = assignedCampData?.find((row) => row.id === id);
    setValue("ai_id", selectedRowData.ai_id);
    setValue("campaign_id", selectedRowData.campaign_id);
  }

  function handleDeleteClick(id) {
    dispatch(deleteAssignedCampaignById(id));
  }

  const onFormSubmit = (data) => {
    const { campaign_id, ai_id } = data;
    const recreatedSchema = {
      ai_id,
      campaign_id,
    };
    if (recreatedSchema) {
      dispatch(assignCampaign(recreatedSchema));
    }
    setAssignCampModal(false);
    setValue("campaign_id", "");
    setValue("ai_id", "");
  };

  React.useEffect(() => {
    const newData = allAssignedCampaignsDetails?.map((item) => ({
      ai_id: item?.aac_ai_id,
      ai_name: item?.agent_name,
      id: item?.aac_id || uuidv4(),
      campaign_id: item?.aac_campaign_id,
      campaign_name: item?.campaign_name,
    }));
    setAssignedCampData(newData);
  }, [allAssignedCampaignsDetails]);

  React.useEffect(() => {
    dispatch(getAllAiAssignedCampaigns());
    dispatch(getUnAssignedCampaigns());
  }, []);

  const columns = [
    // {
    //   field: "id",
    //   headerName: "Id",
    //   width: 180,
    //   headerAlign: "center",
    //   align: "center",
    // },
    {
      field: "ai_id",
      headerName: "Agent ID",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "ai_name",
      headerName: "Agent Name",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "campaign_id",
      headerName: "Campaign Id",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "campaign_name",
      headerName: "Campaign Name",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      headerAlign: "center",
      align: "center", // Center action buttons
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={() => handleViewClick(params.row.id)}
              color="primary"
              title="View"
            >
              <VisibilityIcon />
            </IconButton>
            <IconButton
              onClick={() => handleEditClick(params.row.id)}
              color="info"
              title="Edit"
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={() => handleDeleteClick(params.row.id)}
              color="error"
              title="Delete"
              disabled
            >
              <DeleteIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Box
        sx={{ height: 380, width: "100%" }}
        style={{ margin: "0px 0px 40px 0px" }}
      >
        <Button
          variant="contained"
          onClick={() => {
            setAssignCampModal(() => !assignCampModal);
            dispatch(getUnassignedCampaigns());
            dispatch(getAllAiAgentDetails());
          }}
          sx={{ margin: "10px 0px" }}
        >
          Assign
        </Button>
        <DataGrid
          rows={assignedCampData}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
          disableDensitySelector
          sx={{
            "& .MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-cell": {
              justifyContent: "center",
              display: "flex",
            },
          }}
        />
      </Box>
      <Modal
        open={assignCampModal}
        onClose={handleCloseModal}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <Grid
            sx={{
              ...style,
              width: 600,
              // height: 500,
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignContent: "center",
              borderRadius: "10px",
            }}
          >
            <h3
              className="text-success"
              style={{ textAlign: "center", margin: "20px 0px" }}
            >
              Assign Campaign
            </h3>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
            >
              <Controller
                name="ai_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="number"
                    select
                    label="Agent"
                    margin="normal"
                    className="w-100"
                    error={errors?.ai_id}
                    helperText={""}
                  >
                    {allAgentDetails.map((item) => (
                      <MenuItem key={item?.ai_id} value={item?.ai_id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <Controller
                name="campaign_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="number"
                    select
                    label="Campaign"
                    margin="normal"
                    className="w-100"
                    error={errors?.campaign_id}
                    helperText={""}
                  >
                    {unassignedCampaigns.map((item) => (
                      <MenuItem key={item?.id} value={item?.id}>
                        {item?.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Box>
            <Button
              style={{ margin: "20px 0px" }}
              variant="contained"
              type="submit"
            >
              Submit
            </Button>
          </Grid>
        </form>
      </Modal>{" "}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box
          sx={{
            ...style,
            width: 600,
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h6 className="text-success mb-4">
              Details for Campaign "{modalData?.campaign_name}"
            </h6>
            <div style={{ display: "flex", gap: "20px" }}>
              <span>AI Id:</span>
              <span>{modalData?.ai_id}</span>
            </div>
            <div style={{ display: "flex", gap: "20px" }}>
              <span>Campaign Id:</span>
              <span>{modalData?.campaign_id}</span>
            </div>
          </div>
        </Box>
      </Modal>{" "}
    </>
  );
}
